import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { SelectionBar } from "@/components/site/SelectionBar";
import { MobileTabBar } from "@/components/site/MobileTabBar";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <div className="h-20 xl:hidden" />
      <SelectionBar />
      <WhatsAppFloat />
      <MobileTabBar />
    </div>
  );
};
